import 'css-chunksrc/feature/flip-and-tip/FlipAndTipSignature.module.scss';export default {
  "root": "FlipAndTipSignature_root",
  "canvas_wrapper": "FlipAndTipSignature_canvas_wrapper",
  "canvas_overlay_graphic": "FlipAndTipSignature_canvas_overlay_graphic",
  "action_left": "FlipAndTipSignature_action_left",
  "action_right": "FlipAndTipSignature_action_right"
};